export default __webpack_public_path__ + "static/media/camera-upload.f48f8171.svg";